/* eslint-disable react/prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import MakeModelApprovalPanelProvider from './make-model-approval-provider';
import EditMakeModelApprovalModal from './make-model-approval-request-edit-modal';

const MakeModelApprovalModalWrapper = ({
  isOpen,
  onClose,
  data,
  refetchData,
}) => {
  // Mount the provider only while the modal is open so it seeds cleanly from
  // the selected row each time (this wrapper stays mounted in the table frame).
  if (!isOpen) return null;

  const hasChassis = Boolean(data?.chassisMakeCode && data?.chassisModelCode);

  return (
    <MakeModelApprovalPanelProvider
      initialState={data}
      showChassis={hasChassis}
    >
      <EditMakeModelApprovalModal
        isOpen={isOpen}
        onClose={onClose}
        data={data}
        refetchData={refetchData}
      />
    </MakeModelApprovalPanelProvider>
  );
};

MakeModelApprovalModalWrapper.propTypes = {
  onClose: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  data: PropTypes.shape({
    makeCode: PropTypes.number.isRequired,
    makeName: PropTypes.string.isRequired,
    modelCode: PropTypes.string.isRequired,
    modelName: PropTypes.string.isRequired,
    chassisMakeCode: PropTypes.number,
    chassisModelCode: PropTypes.string,
    makeModelApprovalId: PropTypes.number.isRequired,
  }).isRequired,
};

export default MakeModelApprovalModalWrapper;
